// @flow

import React from 'react';
import { SelectProps } from 'antd/lib/select';
import Select from './../ui/Select';
import range from 'lodash/range';

const { Option } = Select;

let timeRange = {};

range(25).forEach(hour => {
  timeRange[`${hour} ч.`] = hour;
});

// Выпадающий список часов с шагом 1
export default (props: SelectProps) => (
  <Select {...props} allowClear>
    {Object.keys(timeRange).map(group => (
      <Option value={timeRange[group]} key={group}>
        {group}
      </Option>
    ))}
  </Select>
);
